const setSearchQuery = (context, data) => {
  context.commit('SEARCH_QUERY_UPDATED', data)
}

const setSearchContext = (context, type) => {
  context.commit('SEARCH_CONTEXT_UDPATED', type)
}

const setCoursesResultCount = (context, count) => {
  context.commit('SEARCH_COURSES_RESULT_COUNT', count)
}

const setPlaylistsResultCount = (context, count) => {
  context.commit('SEARCH_PLAYLISTS_RESULT_COUNT', count)
}

const setVideosResultCount = (context, count) => {
  context.commit('SEARCH_VIDEOS_RESULT_COUNT', count)
}

const setViewStyle = (context, viewStyle) => {
  context.commit('SEARCH_VIEW_STYLE_UPDATED', viewStyle)
}

const setIsFiltersCollapsed = (context, isFiltersCollapsed) => {
  context.commit('SEARCH_IS_FILTERS_COLLAPSED_UPDATED', isFiltersCollapsed)
}

export default {
  setSearchQuery,
  setSearchContext,
  setCoursesResultCount,
  setPlaylistsResultCount,
  setVideosResultCount,
  setViewStyle,
  setIsFiltersCollapsed,
}
